import { Text, TextProps } from '@chakra-ui/react';
import React from 'react';

interface IProps extends TextProps {
  children: string;
}
const Typography = ({
  children,
  fontFamily = 'Poppins',
  fontStyle = 'normal',
  ...rest
}: IProps) => {
  return (
    <Text {...rest} fontFamily={fontFamily} fontStyle={fontStyle}>
      {children}
    </Text>
  );
};

export default Typography;
